export enum SopStatusResponse {
  AUTHENTICATION_EXPIRED = 'AuthenticationExpiredException',
  CODE_REDEEM_BLOCKED = 'CodeRedeemBlockedException',
  VALIDATION_EXCEPTION = 'ValidationException',
  SHARE_EXPIRED_EXCEPTION = 'ShareExpiredException',
  CODE_REDEEM_EXPIRED_EXCEPTION = 'CodeRedeemExpiredException'
}
